import React from "react";
import "./productList.css";
import Product from "../product/Product";
import products from "../../data";

function ProductList() {
  return (
    <div className="pl">
      <div className="pl-texts">
        <h1 className="pl-title">Projetos</h1>
        <p className="pl-desc">
          Projetos desenvolvidos por mim enquanto Desenvolvedor
          Front-end.
        </p>
      </div>
      <div className="pl-list">
        { products.map((item) => <Product id={ item.id } imagem={ item.img } key={ item.id } />) }
      </div>
    </div>
  );
}

export default ProductList;
